import { combineReducers } from 'redux'
import theme from './slices/themeSlice'
import auth from './slices/authSlice'
import student from "./slices/childSlice"

const rootReducer = (asyncReducers) => (state, action) => {
  const combinedReducer = combineReducers({
    theme,
    auth,
    student,
    ...asyncReducers,
  })
  return combinedReducer(state, action)
}

export default rootReducer